<template>
  <v-expansion-panels class="mb-4">
    <v-expansion-panel>
      <v-expansion-panel-header>Tìm kiếm</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card class="ma-0" outlined>
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="filterForm.keyword"
                    label="Tìm kiếm theo tên"
                    clearable
                    @keyup.enter="search"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-model="filterForm.status"
                    :items="evaluationStatusOptions"
                    item-text="text"
                    item-value="value"
                    label="Tìm kiếm theo trạng thái"
                    placeholder="Trạng thái"
                    color="primary"
                    clearable
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn class="primary mx-0" @click="search">
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { evaluationStatusOptions } from "../../../helpers/constants";

export default {
  name: "FilterForm",
  props: {
    filterForm: {
      default: () => ({}),
    },
  },
  data() {
    return {
      evaluationStatusOptions,
    };
  },
  created() {},
  methods: {
    search() {
      Bus.$emit("evaluation-list-filter", this.filterForm);
    },
  },
};
</script>
